import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { COMMON_BENEFIT_EXCLUDES, useExcludedBenefits } from '../useExcludedBenefits';
import { useOrderedBenefitExtensions } from '../useOrderedBenefits';
import { BenefitButton } from './BenefitButton';
import { BenefitMenuItem } from './BenefitMenuItem';

interface Props {
  onSupportDialogOpen: () => void;
}
const INCLUDED_NAV_BENEFITS: BenefitDTOBenefitEnum[] = [BenefitDTOBenefitEnum.News, BenefitDTOBenefitEnum.DiscountCode];
export const NavBenefitList: React.FC<Props> = ({ onSupportDialogOpen }) => {
  const { t } = useTranslation();
  const { tenant } = useTenant();
  // news and discount code need nav bar entries
  const { excludedBenefits } = useExcludedBenefits(COMMON_BENEFIT_EXCLUDES.filter(benefit => !INCLUDED_NAV_BENEFITS.includes(benefit)));
  const location = useLocation();

  const benefitsToExclude: BenefitDTOBenefitEnum[] = [BenefitDTOBenefitEnum.CouponsV2, BenefitDTOBenefitEnum.Custom, ...excludedBenefits];

  const { orderedBenefits, activeBenefits } = useOrderedBenefitExtensions(tenant, benefitsToExclude);

  return (
    <>
      {orderedBenefits.map(benefitMetadata => {
        const active = activeBenefits.includes(benefitMetadata);

        // match benefit url and subpages
        const targetUrl = RegExp(`^/benefits/${benefitMetadata.benefitId.toLowerCase()}\\b`);

        return (
          <BenefitButton
            selected={targetUrl.test(location.pathname)}
            key={benefitMetadata.benefitId}
            active={active}
            onShowFallback={onSupportDialogOpen}
            benefitMetadata={benefitMetadata}
          />
        );
      })}
      <BenefitMenuItem
        dataTestId="more-benefits-button"
        active={false}
        title={t(`common:moreBenefits`)}
        icon={MoreHorizIcon}
        onClick={onSupportDialogOpen}
      />
    </>
  );
};
